/**
 * Dynamic variables available for WhatsApp campaign templates.
 * These use Liquid syntax and are resolved per-contact during dispatch.
 * Used in: StepVariableConfig (wizard) and WhatsAppCampaignForm (edit).
 */
export const CAMPAIGN_DYNAMIC_VARIABLES = [
  { key: '{{contact.name}}', highlighted: false },
  { key: '{{contact.first_name}}', highlighted: true },
  { key: '{{contact.last_name}}', highlighted: false },
  { key: '{{contact.email}}', highlighted: false },
  { key: '{{contact.phone_number}}', highlighted: false },
];

export const VARIABLE_CHIP_CLASS = 'bg-n-amber-2 text-n-amber-11 font-semibold';
export const VARIABLE_CHIP_HIGHLIGHTED_CLASS =
  'bg-n-amber-3 text-n-amber-11 font-semibold';
